import { render, staticRenderFns } from "./TargetingScrollPercentage.vue?vue&type=template&id=08bb2504&"
import script from "./TargetingScrollPercentage.vue?vue&type=script&lang=js&"
export * from "./TargetingScrollPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports